// extracted by mini-css-extract-plugin
export default {"navi":"Heading_navi__1gXH+","exit":"Heading_exit__c0QBf"};